$ = require 'jquery'
limitErrorPopover = require 'app/scripts/views/lib/limit-error-popover'

canAddCard = (options) ->
  {
    hasChecklists,
    hasAttachments,
    destinationBoard,
    destinationList
  } = options

  !destinationBoard?.isOverLimit('cards', 'openPerBoard') &&
  !destinationBoard?.isOverLimit('cards', 'totalPerBoard') &&
  !destinationList?.isOverLimit('cards', 'openPerList') &&
  !destinationList?.isOverLimit('cards', 'totalPerList') &&
  !destinationBoard?.isOverLimit('attachments', 'perBoard') &&
  !destinationBoard?.isOverLimit('checklists', 'perBoard')

trackingArea = "Card Limits"
maybeDisplayLimitsErrorOnCardAdd = (options) ->
  {
    $elem,
    hasChecklists,
    hasAttachments,
    destinationBoard,
    destinationList
  } = options

  message = if destinationBoard?.isOverLimit('cards', 'openPerBoard')
      'card exceeds open per board limit'
    else if destinationBoard?.isOverLimit('cards', 'totalPerBoard')
      'card exceeds total per board limit'
    else if destinationList?.isOverLimit('cards', 'openPerList')
      'card exceeds open per list limit'
    else if destinationList?.isOverLimit('cards', 'totalPerList')
      'card exceeds total per list limit'
    else if hasAttachments && destinationBoard?.isOverLimit('attachments', 'perBoard')
      'card exceeds attachments per board limit'
    else if hasChecklists && destinationBoard?.isOverLimit('checklists', 'perBoard')
     'card exceeds checklists per board limit'

  if message?
    limitErrorPopover {
      elem: $elem
      message
      params:
        boardName: destinationBoard?.get("name"),
        listName: destinationList?.get("name")
    }
    return true
  return false

maybeDisplayLimitsErrorOnCardOpen = (options) ->
  {
    $elem,
    hasAttachments,
    destinationBoard,
    destinationList
  } = options

  message = if destinationBoard?.isOverLimit('cards', 'openPerBoard')
    'card exceeds open per board limit'
  else if destinationList?.isOverLimit('cards', 'openPerList')
    'card exceeds open per list limit'
  else if hasAttachments && destinationBoard?.isOverLimit('attachments', 'perBoard')
    'card exceeds attachments per board limit'

  if message?
    limitErrorPopover {
      trackingArea
      elem: $elem
      message
      params:
        boardName: destinationBoard?.get("name"),
        listName: destinationList?.get("name")
    }
    return true
  return false

module.exports = {
  canAddCard,
  maybeDisplayLimitsErrorOnCardAdd,
  maybeDisplayLimitsErrorOnCardOpen,
}
